export const BASE_DELETE_ACCOUNT_ROUTE = '/settings/delete-account';
